import store from "@/store";

const routes = [
    {
        path: '/company/supplier-world/search/supplier',
        name: 'CompanySWSearchSuppliers',
        component: () => import('../../views/company/supplier_world/search/Suppliers.vue')
    },
    {
        path: '/company/supplier-world/search/supplier/:id/details',
        name: 'CompanySWSearchSupplier',
        component: () => import('../../views/company/supplier_world/search/Supplier.vue')
    },
    {
        path: '/company/supplier-world/search/director_shareholder',
        name: 'CompanySWSearchDirectorShareholder',
        component: () => import('../../views/company/supplier_world/search/Director_Shareholder.vue')
    },
    {
        path: '/company/supplier-world/supplier-list',
        name: 'CompanySWSupplierList',
        component: () => import('../../views/company/supplier_world/supplier_management/SupplierList.vue'),
        beforeEnter: (to, from, next) => {
          let obj = store.state.User.userData.user_type === 'buyer' && store.state.Auth.privileges.some(privilege => privilege.title === 'SUPPLIER_MANAGEMENT')
          if(obj === true) {
            next()
          } else {
            next({ name: 'permissions-error' })
          }
        }
    },
    {
        path: '/company/supplier-world/edit-supplier-details/:id',
        name: 'CompanySupplierEdit',
        component: () => import('../../views/company/supplier_world/supplier_management/EditSupplierDetails.vue'),
        beforeEnter: (to, from, next) => {
          let obj = store.state.User.userData.user_type === 'buyer' && store.state.Auth.privileges.some(privilege => privilege.title === 'SUPPLIER_MANAGEMENT')
          if(obj === true) {
            next()
          } else {
            next({ name: 'permissions-error' })
          }
        }
    },
]

export default routes;